export const countries = [
  {
    name: "Not specified",
    country_code: "not_specified",
    flag: null
  },
  {
    name: "Afghanistan",
    country_code: "AF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/afghanistan_1LrkIK1_ZKw66J5.svg"
  },
  {
    name: "Åland Islands",
    country_code: "AX",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/%C3%A5land_islands_F31kLxo_7AN1Bsm.svg"
  },
  {
    name: "Albania",
    country_code: "AL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/albania_uPrtSWm_5S4ClON.svg"
  },
  {
    name: "Algeria",
    country_code: "DZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/algeria_DbJphIm_8h2fyMg.svg"
  },
  {
    name: "American Samoa",
    country_code: "AS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/american_samoa.svg"
  },
  {
    name: "Andorra",
    country_code: "AD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/andorra_vaALoMa_ZB2FKnk.svg"
  },
  {
    name: "Angola",
    country_code: "AO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/angola_VF0YYFg_9lbF8yN.svg"
  },
  {
    name: "Anguilla",
    country_code: "AI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/anguilla_BNpWBP3_7RzHV09.svg"
  },
  {
    name: "Antarctica",
    country_code: "AQ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/antarctica.svg"
  },
  {
    name: "Antigua & Barbuda",
    country_code: "AG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/antigua__barbuda_2UfOgDU_dv21rnk.svg"
  },
  {
    name: "Argentina",
    country_code: "AR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/argentina_qZw6HHC_510OikH.svg"
  },
  {
    name: "Armenia",
    country_code: "AM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/armenia_c41ZCYb_FWE8YYB.svg"
  },
  {
    name: "Aruba",
    country_code: "AW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/aruba_hy2wct6_I0hfbPY.svg"
  },
  {
    name: "Australia",
    country_code: "AU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/australia_iHPx7DL_6tJJXUU.svg"
  },
  {
    name: "Austria",
    country_code: "AT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/austria_Mpbmr6v_6JTLrhg.svg"
  },
  {
    name: "Azerbaijan",
    country_code: "AZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/azerbaijan_4tMZ9RV_hOBtUBj.svg"
  },
  {
    name: "Bahamas",
    country_code: "BS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bahamas_eLQ8Cfi_qanckEe.svg"
  },
  {
    name: "Bahrain",
    country_code: "BH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bahrain_0uF2Faa_PsWEuuA.svg"
  },
  {
    name: "Bangladesh",
    country_code: "BD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bangladesh_BwIPm0U_5auhaNE.svg"
  },
  {
    name: "Barbados",
    country_code: "BB",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/barbados_SBZFGOE_NQe8y1n.svg"
  },
  {
    name: "Belarus",
    country_code: "BY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/belarus_3APhIj6_z2YAtIb.svg"
  },
  {
    name: "Belgium",
    country_code: "BE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/belgium_V5T0nLd_XoFRQa0.svg"
  },
  {
    name: "Belize",
    country_code: "BZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/belize_py2Lny5_tsVPlAN.svg"
  },
  {
    name: "Benin",
    country_code: "BJ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/benin_GpFdtMM_jRb1UDH.svg"
  },
  {
    name: "Bermuda",
    country_code: "BM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bermuda_te6RLAU_DTNlGmk.svg"
  },
  {
    name: "Bhutan",
    country_code: "BT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bhutan_SeE15kb_B9xmAel.svg"
  },
  {
    name: "Bolivia",
    country_code: "BO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bolivia_vtPyHUm_j3QFicS.svg"
  },
  {
    name: "Caribbean Netherlands",
    country_code: "BQ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/caribbean_netherlands_FEx01mt_bKT8Njm.svg"
  },
  {
    name: "Bosnia & Herzegovina",
    country_code: "BA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bosnia__herzegovina_F9jiMNs_GMU1VWm.svg"
  },
  {
    name: "Botswana",
    country_code: "BW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/botswana_EaDuggR_icWadgl.svg"
  },
  {
    name: "Bouvet Island",
    country_code: "BV",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bouvet_island.svg"
  },
  {
    name: "Brazil",
    country_code: "BR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/brazil_xZV43NL_Jy0508z.svg"
  },
  {
    name: "British Indian Ocean Territory",
    country_code: "IO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/british_indian_ocean_territory_ONYLVeb_szDJ898.svg"
  },
  {
    name: "Brunei",
    country_code: "BN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/brunei_mxa3OsO_tyDCy4p.svg"
  },
  {
    name: "Bulgaria",
    country_code: "BG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/bulgaria_l9BIrV6_mmhzJ9t.svg"
  },
  {
    name: "Burkina Faso",
    country_code: "BF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/burkina_faso_kWQ5k6P_5VPRxgg.svg"
  },
  {
    name: "Burundi",
    country_code: "BI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/burundi_hWwWkOX_t3khNNW.svg"
  },
  {
    name: "Cape Verde",
    country_code: "CV",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cape_verde_kv9AHLo_QRF4eO4.svg"
  },
  {
    name: "Cambodia",
    country_code: "KH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cambodia_fNH5Spo_dhWZt5u.svg"
  },
  {
    name: "Cameroon",
    country_code: "CM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cameroon_Nv5MZlq_Bbn5OR7.svg"
  },
  {
    name: "Canada",
    country_code: "CA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/canada_ZXt103p_jiuGJfB.svg"
  },
  {
    name: "Cayman Islands",
    country_code: "KY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cayman_islands_geLMzBG_mniH6Ml.svg"
  },
  {
    name: "Central African Republic",
    country_code: "CF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/central_african_republic_FiX2MtQ_Aa3OueD.svg"
  },
  {
    name: "Chad",
    country_code: "TD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/chad_yfMyNXT_x7QRm2Y.svg"
  },
  {
    name: "Chile",
    country_code: "CL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/chile_E6XLil3_CTyTZ0L.svg"
  },
  {
    name: "China",
    country_code: "CN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/china_u55jQmv_Lq4lPCV.svg"
  },
  {
    name: "Christmas Island",
    country_code: "CX",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/christmas_island_PezFGz1_RPPrAAe.svg"
  },
  {
    name: "Cocos (Keeling) Islands",
    country_code: "CC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cocos_keeling_islands_eGaKs6U_VKNRG90.svg"
  },
  {
    name: "Colombia",
    country_code: "CO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/colombia_ceHDA8Y_xZGWS6a.svg"
  },
  {
    name: "Comoros",
    country_code: "KM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/comoros_LFwntob_5qI7qQn.svg"
  },
  {
    name: "Congo - Brazzaville",
    country_code: "CG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/congo_-_brazzaville_ov9qiBM_9kd5wFY.svg"
  },
  {
    name: "Congo - Kinshasa",
    country_code: "CD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/congo_-_kinshasa_O5HWCiO_RO9TQjo.svg"
  },
  {
    name: "Cook Islands",
    country_code: "CK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cook_islands_HIdhN0l_PRvla8c.svg"
  },
  {
    name: "Costa Rica",
    country_code: "CR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/costa_rica_n0fjjmI_4cidXGj.svg"
  },
  {
    name: "Côte d’Ivoire",
    country_code: "CI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/c%C3%B4te_divoire_tbZivqo_waHqNKM.svg"
  },
  {
    name: "Croatia",
    country_code: "HR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/croatia_37AUzXi_YNrpiC2.svg"
  },
  {
    name: "Cuba",
    country_code: "CU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cuba.svg"
  },
  {
    name: "Curaçao",
    country_code: "CW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cura%C3%A7ao_gzu9yPM_LSTgeXc.svg"
  },
  {
    name: "Cyprus",
    country_code: "CY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/cyprus_v9w0RI8_BAkct1Z.svg"
  },
  {
    name: "Czechia",
    country_code: "CZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/czechia_laYvCrT_eDSkmKK.svg"
  },
  {
    name: "Denmark",
    country_code: "DK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/denmark_YvQRcxw_7FHQ04V.svg"
  },
  {
    name: "Djibouti",
    country_code: "DJ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/djibouti_7q99I32_2SStYkV.svg"
  },
  {
    name: "Dominica",
    country_code: "DM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/dominica_7RvQGdV_ButOklt.svg"
  },
  {
    name: "Dominican Republic",
    country_code: "DO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/dominican_republic_p8Cl0qf_tq8kT7B.svg"
  },
  {
    name: "Ecuador",
    country_code: "EC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/ecuador_X4a9vEt_HrKRyu5.svg"
  },
  {
    name: "Egypt",
    country_code: "EG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/egypt_F8nI6bM_vmPCwOH.svg"
  },
  {
    name: "El Salvador",
    country_code: "SV",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/el_salvador_EfM3Vj5_yjl4MAJ.svg"
  },
  {
    name: "Equatorial Guinea",
    country_code: "GQ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/equatorial_guinea_cb4dwhd_OvIsgXm.svg"
  },
  {
    name: "Eritrea",
    country_code: "ER",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/eritrea_3mYaKBh_ePDvI76.svg"
  },
  {
    name: "Estonia",
    country_code: "EE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/estonia_AAZTjkR_VXL2qDY.svg"
  },
  {
    name: "Ethiopia",
    country_code: "ET",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/ethiopia_Fo6lj9x_MzcH4wq.svg"
  },
  {
    name: "Falkland Islands",
    country_code: "FK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/falkland_islands_IsNDkHt_zGxbQo9.svg"
  },
  {
    name: "Faroe Islands",
    country_code: "FO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/faroe_islands_7QqTZRm_i0ACByL.svg"
  },
  {
    name: "Fiji",
    country_code: "FJ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/fiji_tNYcL0x_fem8h3F.svg"
  },
  {
    name: "Finland",
    country_code: "FI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/finland_QxmLXW4_UUyfaN5.svg"
  },
  {
    name: "France",
    country_code: "FR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/france_7z4LWbN_YfKFyI0.svg"
  },
  {
    name: "French Guiana",
    country_code: "GF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/french_guiana_VnibHUx_dWuaQwM.svg"
  },
  {
    name: "French Polynesia",
    country_code: "PF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/french_polynesia_pac0Y2T_eIf3JOI.svg"
  },
  {
    name: "French Southern Territories",
    country_code: "TF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/French_Southern_and_Antarctic_Lands_97RvRZp.svg"
  },
  {
    name: "Gabon",
    country_code: "GA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/gabon_Fza1ctT_gHagEpG.svg"
  },
  {
    name: "Gambia",
    country_code: "GM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/gambia_Mw7jYZI_oRb8syf.svg"
  },
  {
    name: "Georgia",
    country_code: "GE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/georgia_RtgpX2r_GWYkuSz.svg"
  },
  {
    name: "Germany",
    country_code: "DE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/germany_UoMessR_rxjFaSI.svg"
  },
  {
    name: "Ghana",
    country_code: "GH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/ghana_Kow37Qy_xLDTeUQ.svg"
  },
  {
    name: "Gibraltar",
    country_code: "GI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/gibraltar_feCQr3a_XAhM8vJ.svg"
  },
  {
    name: "Greece",
    country_code: "GR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/greece_mS8VZWc_kr2wW6l.svg"
  },
  {
    name: "Greenland",
    country_code: "GL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/greenland_9zEmU2t_qmuEsHy.svg"
  },
  {
    name: "Grenada",
    country_code: "GD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/grenada_3pKiT4O_74kJDlq.svg"
  },
  {
    name: "Guadeloupe",
    country_code: "GP",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/france_poYeUYn_dEGWaSh_2gPBk8i.svg"
  },
  {
    name: "Guam",
    country_code: "GU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/guam.svg"
  },
  {
    name: "Guatemala",
    country_code: "GT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/guatemala_UrUXLDL_4iepGkO.svg"
  },
  {
    name: "Guernsey",
    country_code: "GG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/guernsey_ToDvb6X_srde0Pa.svg"
  },
  {
    name: "Guinea",
    country_code: "GN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/guinea_fPWxVaO_H7ESWuq.svg"
  },
  {
    name: "Guinea-Bissau",
    country_code: "GW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/guinea-bissau_rElsknf_WZFS54h.svg"
  },
  {
    name: "Guyana",
    country_code: "GY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/guyana_bggtCMp_Cl5S7WV.svg"
  },
  {
    name: "Haiti",
    country_code: "HT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/haiti_W6PADF9_6k50aVD.svg"
  },
  {
    name: "HIMI",
    country_code: "HM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/himi.svg"
  },
  {
    name: "Vatican City",
    country_code: "VA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/vatican_city_2gWzAK3_Z1OK3Sh.svg"
  },
  {
    name: "Honduras",
    country_code: "HN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/honduras_hoMmJAj_3xnzyr6.svg"
  },
  {
    name: "Hong Kong SAR",
    country_code: "HK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/hong_kong_sar_s6cSGys_Wc7xXtc.svg"
  },
  {
    name: "Hungary",
    country_code: "HU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/hungary_Maet5eF_kBl38fV.svg"
  },
  {
    name: "Iceland",
    country_code: "IS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/iceland_QDZbzc1_TkOvRMG.svg"
  },
  {
    name: "India",
    country_code: "IN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/india_sTREXxF_eGEchwt.svg"
  },
  {
    name: "Indonesia",
    country_code: "ID",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/indonesia_VWNHhre_3hM268G.svg"
  },
  {
    name: "Iran",
    country_code: "IR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/iran.svg"
  },
  {
    name: "Iraq",
    country_code: "IQ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/iraq_t4IqsEa_OwL9LWp.svg"
  },
  {
    name: "Ireland",
    country_code: "IE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/ireland_CZigPNd_xgYZ2nc.svg"
  },
  {
    name: "Isle of Man",
    country_code: "IM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/isle_of_man_eNwsjpr_5G85UIW.svg"
  },
  {
    name: "Israel",
    country_code: "IL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/israel_AuW4wVB_zAB63CH.svg"
  },
  {
    name: "Italy",
    country_code: "IT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/italy_6We3GB5_pFOBUDo.svg"
  },
  {
    name: "Jamaica",
    country_code: "JM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/jamaica_ktVZsyr_QHpSPi7.svg"
  },
  {
    name: "Japan",
    country_code: "JP",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/japan_9SupCDP_KK4Mrqt.svg"
  },
  {
    name: "Jersey",
    country_code: "JE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/jersey_YEDBCBx_rPwhLis.svg"
  },
  {
    name: "Jordan",
    country_code: "JO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/jordan_HwD84ui_y98xcJ5.svg"
  },
  {
    name: "Kazakhstan",
    country_code: "KZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/kazakhstan_i4ewVBm_cbZvMCp.svg"
  },
  {
    name: "Kenya",
    country_code: "KE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/kenya_4gFlRZj_Sq3H3gC.svg"
  },
  {
    name: "Kiribati",
    country_code: "KI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/kiribati_BRpe5Za_0Veiq2R.svg"
  },
  {
    name: "South Korea",
    country_code: "KR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/south_korea.svg"
  },
  {
    name: "North Korea",
    country_code: "KP",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/north_korea.png"
  },
  {
    name: "Kuwait",
    country_code: "KW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/kuwait_4FBMxP1_x8yCRqP.svg"
  },
  {
    name: "Kyrgyzstan",
    country_code: "KG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/kyrgyzstan_e6wTLnD_55vMHv8.svg"
  },
  {
    name: "Laos",
    country_code: "LA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/laos_61vHxTd_6YQM7Ae.svg"
  },
  {
    name: "Latvia",
    country_code: "LV",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/latvia_4z18kfH_cCWFKWk.svg"
  },
  {
    name: "Lebanon",
    country_code: "LB",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/lebanon_lufcMze_n4snRWE.svg"
  },
  {
    name: "Lesotho",
    country_code: "LS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/lesotho_9hwJLfJ_EG0Idrs.svg"
  },
  {
    name: "Liberia",
    country_code: "LR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/liberia_Fa7Xctf_d6MeSr8.svg"
  },
  {
    name: "Libya",
    country_code: "LY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/libya_gk78vIG_vr6R994.svg"
  },
  {
    name: "Liechtenstein",
    country_code: "LI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/liechtenstein_ZKpDH9E_zZ2Pted.svg"
  },
  {
    name: "Lithuania",
    country_code: "LT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/lithuania_OeUhSvd_5dqokzm.svg"
  },
  {
    name: "Luxembourg",
    country_code: "LU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/luxembourg_NQQOFMF_ESIZRqN.svg"
  },
  {
    name: "Macao SAR",
    country_code: "MO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/macao_sar_ZXKJlir_2hTspUo.svg"
  },
  {
    name: "North Macedonia",
    country_code: "MK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/republic-of-macedonia_jMkifLI_yzN72L4.svg"
  },
  {
    name: "Madagascar",
    country_code: "MG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/madagascar_pxHqFTl_K13ypDm.svg"
  },
  {
    name: "Malawi",
    country_code: "MW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/malawi_hHvw0et_r14JbQO.svg"
  },
  {
    name: "Malaysia",
    country_code: "MY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/malaysia_Rl1g4wK_s69PYoG.svg"
  },
  {
    name: "Maldives",
    country_code: "MV",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/maldives_f6fZIgM_nMaHcWd.svg"
  },
  {
    name: "Mali",
    country_code: "ML",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mali_CuCxIg3_LBv6vy9.svg"
  },
  {
    name: "Malta",
    country_code: "MT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/malta_Pi3XnLB_K43ukbM.svg"
  },
  {
    name: "Marshall Islands",
    country_code: "MH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/marshall_island.svg"
  },
  {
    name: "Martinique",
    country_code: "MQ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/martinique_Klxo0L0_lLk7vhJ.svg"
  },
  {
    name: "Mauritania",
    country_code: "MR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mauritania_eub4SBY_64uinN0.svg"
  },
  {
    name: "Mauritius",
    country_code: "MU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mauritius_cPicX3w_m03V27z.svg"
  },
  {
    name: "Mayotte",
    country_code: "YT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mayotte_HxV3rqS_WsxwRww.svg"
  },
  {
    name: "Mexico",
    country_code: "MX",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mexico_zzs5zzh_LdTsJuL.svg"
  },
  {
    name: "Micronesia",
    country_code: "FM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/micronesia.svg"
  },
  {
    name: "Moldova",
    country_code: "MD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/moldova_8AQisep_uOr9ZHm.svg"
  },
  {
    name: "Monaco",
    country_code: "MC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/monaco_ZjcrjBa_31LSUGk.svg"
  },
  {
    name: "Mongolia",
    country_code: "MN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mongolia_X1xkJC2_aZcRuef.svg"
  },
  {
    name: "Montenegro",
    country_code: "ME",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/montenegro_AYjUO77_XYcsbI3.svg"
  },
  {
    name: "Montserrat",
    country_code: "MS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/montserrat_qIOIHSA_b49lyE1.svg"
  },
  {
    name: "Morocco",
    country_code: "MA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/morocco_mllhgHl_RBLyYNC.svg"
  },
  {
    name: "Mozambique",
    country_code: "MZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/mozambique_LAcfd95_zwbFAjq.svg"
  },
  {
    name: "Myanmar (Burma)",
    country_code: "MM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/myanmar_burma_lbJ2aMP_FOYHdon.svg"
  },
  {
    name: "Namibia",
    country_code: "NA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/namibia_iO4Yr82_qMdUVmB.svg"
  },
  {
    name: "Nauru",
    country_code: "NR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/nauru_4wMbxWM_1fuhFb6.svg"
  },
  {
    name: "Nepal",
    country_code: "NP",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/nepal_Uh9X8it_YXYdV4f.svg"
  },
  {
    name: "Netherlands",
    country_code: "NL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/netherlands_oljy6el_WiPHRk7.svg"
  },
  {
    name: "New Caledonia",
    country_code: "NC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/new_caledonia_w9eJSvU_uRC1XOr.svg"
  },
  {
    name: "New Zealand",
    country_code: "NZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/new_zealand_jZpjXyd_4Ku4bnh.svg"
  },
  {
    name: "Nicaragua",
    country_code: "NI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/nicaragua_SzSXty4_wjRmugV.svg"
  },
  {
    name: "Niger",
    country_code: "NE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/niger_pLAVlqr_HNWPyGM.svg"
  },
  {
    name: "Nigeria",
    country_code: "NG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/nigeria_3FirpiA_ynRjVRc.svg"
  },
  {
    name: "Niue",
    country_code: "NU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/niue_jgv9DR5_vQmIDwu.svg"
  },
  {
    name: "Norfolk Island",
    country_code: "NF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/norfolk_island_ui9qlbC_EmcVSOM.svg"
  },
  {
    name: "Northern Mariana Islands",
    country_code: "MP",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/northern_mariana_islands.svg"
  },
  {
    name: "Norway",
    country_code: "NO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/norway_zbMpxMq_jVMgsTx.svg"
  },
  {
    name: "Oman",
    country_code: "OM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/oman_O8NDNXN_Vc8HTYn.svg"
  },
  {
    name: "Pakistan",
    country_code: "PK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/pakistan_poVLCgP_OBygdUs.svg"
  },
  {
    name: "Palau",
    country_code: "PW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/palau.svg"
  },
  {
    name: "Palestinian Territories",
    country_code: "PS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/palestinian_territories_lkmZfWX_gIteE3b.svg"
  },
  {
    name: "Panama",
    country_code: "PA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/panama_l7SBflA_rDWsho4.svg"
  },
  {
    name: "Papua New Guinea",
    country_code: "PG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/papua_new_guinea_eQukakV_dFS50Xg.svg"
  },
  {
    name: "Paraguay",
    country_code: "PY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/paraguay_cg1RDGh_sks7M3z.svg"
  },
  {
    name: "Peru",
    country_code: "PE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/peru_0d0A6LM_9Hv5OCb.svg"
  },
  {
    name: "Philippines",
    country_code: "PH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/philippines_4rjhVmr_QGuOdr1.svg"
  },
  {
    name: "Pitcairn Islands",
    country_code: "PN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/pitcairn_islands_nqNXIJD_FM9YhIe.svg"
  },
  {
    name: "Poland",
    country_code: "PL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/poland_t5rFUx0_Z3V6qsR.svg"
  },
  {
    name: "Portugal",
    country_code: "PT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/portugal_iVwpYRN_87HTHuB.svg"
  },
  {
    name: "Puerto Rico",
    country_code: "PR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/puerto_rico.svg"
  },
  {
    name: "Qatar",
    country_code: "QA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/qatar_k7z7B0u_INFJUTP.svg"
  },
  {
    name: "Réunion",
    country_code: "RE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/r%C3%A9union_ZEUEgQg_3pNzoYT.svg"
  },
  {
    name: "Romania",
    country_code: "RO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/romania_F1qllUu_JZf8QOF.svg"
  },
  {
    name: "russia",
    country_code: "RU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/russia_i1CQUBH_KnPd3eV.svg"
  },
  {
    name: "Rwanda",
    country_code: "RW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/rwanda_MS4TIR6_yppB5Sp.svg"
  },
  {
    name: "St. Barthélemy",
    country_code: "BL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/st._barth%C3%A9lemy_zfokbad_wDfJcrg.svg"
  },
  {
    name: "St. Helena",
    country_code: "SH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/Saint_Helena_JY9QfLG.svg"
  },
  {
    name: "St. Kitts & Nevis",
    country_code: "KN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/st._kitts__nevis_ruPcM2X_BBwyHPd.svg"
  },
  {
    name: "St. Lucia",
    country_code: "LC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/st._lucia_fTOFfuH_D27yOc4.svg"
  },
  {
    name: "St. Martin",
    country_code: "MF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/france_hJ5QecO_NFxMdqn_OfcLLM1.svg"
  },
  {
    name: "St. Pierre & Miquelon",
    country_code: "PM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/france_ch2YuG1_KOl6Q3n_hdWzUdb.svg"
  },
  {
    name: "St. Vincent & Grenadines",
    country_code: "VC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/st._vincent__grenadines_yjd760i_XoD5k3P.svg"
  },
  {
    name: "Samoa",
    country_code: "WS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/samoa_wap0cJm_qrBplpY.svg"
  },
  {
    name: "San Marino",
    country_code: "SM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/san_marino_0Trh4dO_zAHDiuW.svg"
  },
  {
    name: "São Tomé & Príncipe",
    country_code: "ST",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/s%C3%A3o_tom%C3%A9__pr%C3%ADncipe_Y6YpASc_ZmleUYp.svg"
  },
  {
    name: "Saudi Arabia",
    country_code: "SA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/saudi_arabia_HJAu9vK_pOrXt1t.svg"
  },
  {
    name: "Senegal",
    country_code: "SN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/senegal_7ugUPbO_EhXTHah.svg"
  },
  {
    name: "Serbia",
    country_code: "RS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/serbia_WEjlLjf_u0WzRlU.svg"
  },
  {
    name: "Seychelles",
    country_code: "SC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/seychelles_igpn0xN_SA1KNTJ.svg"
  },
  {
    name: "Sierra Leone",
    country_code: "SL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/sierra_leone_PqEai5I_mPz7Aky.svg"
  },
  {
    name: "Singapore",
    country_code: "SG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/singapore_AgIqpLb_2IbvJ1R.svg"
  },
  {
    name: "Sint Maarten",
    country_code: "SX",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/sint_maarten_ql7Isk0_lgf4IBA.svg"
  },
  {
    name: "Slovakia",
    country_code: "SK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/slovakia_APiFVc9_XN8ZgJg.svg"
  },
  {
    name: "Slovenia",
    country_code: "SI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/slovenia_If7KAU3_3gimKt2.svg"
  },
  {
    name: "Solomon Islands",
    country_code: "SB",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/solomon_islands_yvfuVii_oNtuwH7.svg"
  },
  {
    name: "Somalia",
    country_code: "SO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/somalia_t2cr88l_7g0WkXH.svg"
  },
  {
    name: "South Africa",
    country_code: "ZA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/south_africa_Y08WicU_Seaugg8.svg"
  },
  {
    name: "SGSSI",
    country_code: "GS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/South_Georgia_and_the_South_Sandwich_Islands_BDR40v5.svg"
  },
  {
    name: "South Sudan",
    country_code: "SS",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/south_sudan_YbXsQOG_217QUf7.svg"
  },
  {
    name: "Spain",
    country_code: "ES",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/spain_HBUcENy_XzjRKxO.svg"
  },
  {
    name: "Sri Lanka",
    country_code: "LK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/sri_lanka_DbavRSK_xIMsbJ9.svg"
  },
  {
    name: "Sudan",
    country_code: "SD",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/sudan_9wBiGy5_sMh6uLf.svg"
  },
  {
    name: "Suriname",
    country_code: "SR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/suriname_7zfOCID_AkLctbx.svg"
  },
  {
    name: "Svalbard & Jan Mayen",
    country_code: "SJ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/norway_zbMpxMq_jVMgsTx_pdyeOGg.svg"
  },
  {
    name: "Eswatini",
    country_code: "SZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/Eswatini_WnJd8jz.svg"
  },
  {
    name: "Sweden",
    country_code: "SE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/sweden_IgPF7Op_Gz1oQNX.svg"
  },
  {
    name: "Switzerland",
    country_code: "CH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/switzerland_bKN7BCA_9ubk1w1.svg"
  },
  {
    name: "Syrian Arab Republic",
    country_code: "SY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/syria.svg"
  },
  {
    name: "Taiwan",
    country_code: "TW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/taiwan_uK8rhCG_5alWfbt.svg"
  },
  {
    name: "Tajikistan",
    country_code: "TJ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/tajikistan_ADkb8Om_NCKIvJN.svg"
  },
  {
    name: "Tanzania",
    country_code: "TZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/tanzania_XSSFaHS_wXwxoiW.svg"
  },
  {
    name: "Thailand",
    country_code: "TH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/thailand_Jw9dXeB_DMiTloV.svg"
  },
  {
    name: "Timor-Leste",
    country_code: "TL",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/timor-leste_Li4nrdk_lbqxdgL.svg"
  },
  {
    name: "Togo",
    country_code: "TG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/togo_Ejzc2vq_daBQe3C.svg"
  },
  {
    name: "Tokelau",
    country_code: "TK",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/tokelau_jDSjPf9_jfFFEeI.svg"
  },
  {
    name: "Tonga",
    country_code: "TO",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/tonga_JJmO9Sx_mAg0cT6.svg"
  },
  {
    name: "Trinidad & Tobago",
    country_code: "TT",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/trinidad__tobago_slCmMA5_ZhkSxtJ.svg"
  },
  {
    name: "Tunisia",
    country_code: "TN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/tunisia_AXbhV7i_RpPpCmt.svg"
  },
  {
    name: "Turkey",
    country_code: "TR",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/turkey_qTHR2wk_pD2YyiS.svg"
  },
  {
    name: "Turkmenistan",
    country_code: "TM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/turkmenistan_HwzaMac_VUU4rjb.svg"
  },
  {
    name: "Turks & Caicos Islands",
    country_code: "TC",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/turks__caicos_islands_7FfGRQy_etbbH2q.svg"
  },
  {
    name: "Tuvalu",
    country_code: "TV",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/tuvalu_IC1bizV_ZOAOU95.svg"
  },
  {
    name: "Uganda",
    country_code: "UG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/uganda_DdxynYZ_gompjDS.svg"
  },
  {
    name: "Ukraine",
    country_code: "UA",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/ukraine_QX1x0Wt_30FB1QF.svg"
  },
  {
    name: "United Arab Emirates",
    country_code: "AE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/united_arab_emirates_DbgMPgz_ntXgQkE.svg"
  },
  {
    name: "United Kingdom",
    country_code: "GB",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/united_kingdom_ptsQgr1_sl6kfKA.svg"
  },
  {
    name: "United States",
    country_code: "US",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/united_states_cnnCsmH_ag9hSUC.svg"
  },
  {
    name: "U.S. Outlying Islands",
    country_code: "UM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/u.s._outlying_islands_8OJRBNk_HO8PQ2M.svg"
  },
  {
    name: "Uruguay",
    country_code: "UY",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/uruguay_gvWZZ1V_oRyX50y.svg"
  },
  {
    name: "Uzbekistan",
    country_code: "UZ",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/uzbekistan_7OJIO8V_bxbFaBQ.svg"
  },
  {
    name: "Vanuatu",
    country_code: "VU",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/vanuatu_nG7xgU5_eivtSxh.svg"
  },
  {
    name: "Venezuela",
    country_code: "VE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/venezuela_Alv7WGh_KNozqOp.svg"
  },
  {
    name: "Vietnam",
    country_code: "VN",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/vietnam_iNL72VN_GsXfV4r.svg"
  },
  {
    name: "British Virgin Islands",
    country_code: "VG",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/british_virgin_islands_3WEPx7x_rpbtctu.svg"
  },
  {
    name: "Virgin Islands (U.S.)",
    country_code: "VI",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/virgin_islands.svg"
  },
  {
    name: "Wallis & Futuna",
    country_code: "WF",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/france_OjkR0Qh_ACo2OUL_rZnncq9.svg"
  },
  {
    name: "Western Sahara",
    country_code: "EH",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/western_sahara_rHlGKV9_PZMbdqX.svg"
  },
  {
    name: "Yemen",
    country_code: "YE",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/yemen_kFVvXWq_cMGkBqt.svg"
  },
  {
    name: "Zambia",
    country_code: "ZM",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/zambia_SVMDvo1_GDTSoD2.svg"
  },
  {
    name: "Zimbabwe",
    country_code: "ZW",
    flag: "https://chb-media.s3.amazonaws.com/country_flags/zimbabwe_5hjNtvO_KIDaX35.svg"
  }
]

export const countryFlagsByCountry = countries.reduce((acc, country) => {
  acc[country.name] = country.flag
  return acc
}, {})

export const countryCodesByCountry = countries.reduce((acc, country) => {
  acc[country.name] = country.country_code
  return acc
}, {})

// The dashboard's "Alerts by Country" chart reads country names straight off the backend
// (ISO 3166 short names), which don't always match this list's CLDR-style names above -
// confirmed via the flag-axis plugin logging `undefined` codes for these two.
const BACKEND_NAME_ALIASES = {
  Myanmar: "Myanmar (Burma)",
  "Congo (Republic)": "Congo - Brazzaville"
}
Object.entries(BACKEND_NAME_ALIASES).forEach(([backendName, listName]) => {
  countryFlagsByCountry[backendName] = countryFlagsByCountry[listName]
  countryCodesByCountry[backendName] = countryCodesByCountry[listName]
})

// "Not specified" is a filter sentinel, not a country: its `country_code` is not an ISO code, and
// flag-icons carries no `not_specified.svg`, so asking for that flag renders a broken image
// (CHA1-2885). Flag call sites resolve codes through this instead - it yields null for the
// sentinel, so the row just shows the label with an empty space where a flag would be. The filter
// dropdowns keep reading the raw code off `countries`, which is what the backend expects.
export const NOT_SPECIFIED_COUNTRY_CODE = "not_specified"

export const getCountryFlagCode = (countryName) => {
  const code = countryCodesByCountry[countryName]
  return code && code !== NOT_SPECIFIED_COUNTRY_CODE ? code : null
}

export const countryFlagsByCountryCode = countries.reduce((acc, country) => {
  acc[country.country_code] = country.flag
  return acc
}, {})

export const statuses = ["in_progress", "auto_refunded", "manually_refunded", "attention", "lost"]

const alert_reason = [
  "Account Number Not on File",
  "Addendum, No-show, or ATM Dispute",
  "Airline Transaction Dispute",
  "Altered Amount",
  "Authorization Category",
  "Authorization Related",
  "Authorization-related Chargeback",
  "Canceled Recurring or Digital Goods Transactions",
  "Cancelled Merchandise/Services",
  "Cancelled Recurring Billing",
  "Cancelled Recurring Transaction",
  "Cancelled Reservation",
  "Card Recovery Bulletin",
  "Cardholder Dispute",
  "Cardholder Dispute, Not Elsewhere Yes Classified (U.S. Region Only)",
  "Cardholder Dispute, Not Elsewhere Classified (other)",
  "Cardholder Disputes Quality of Goods or Services",
  "Cardholder Does Not Recognize",
  "Cardholder Does Not Recognize Transaction",
  "Cardholder Does Not Recognize, Potential Sometimes Fraud",
  "Cash Advance Dispute",
  "Charge Processed as Credit",
  "Chargeback Authorization",
  "Chip Liability Shift",
  "Chip/PIN Liability Shift",
  "Consumer Disputes Category",
  "Correct Transaction Currency Code Not Provided",
  "Counterfeit Merchandise",
  "Counterfeit Transaction",
  "Credit (or partial credit) Not Processed",
  "Credit Card Activated Telephone Transaction",
  "Credit Not Processed",
  "Credit Posted as Debit",
  "Credit Processed as Charge",
  "Credit/Debit Posted Incorrectly",
  "Currency Discrepancy",
  "Declined Authorization",
  "Does Not Recognize",
  "Domestic Chargeback Dispute (Europe Yes region Only)",
  "Duplicate Charge",
  "Duplicate Posting",
  "Duplicate Processing",
  "Duplicate Processing/Paid by Other Means",
  "EMV Liability Shift Counterfeit Fraud",
  "EMV Liability Shift Non-Counterfeit Fraud",
  "Expired Card",
  "Fraud Category",
  "Fraud Full Recourse Program",
  "Fraud-Card Not Present Transaction",
  "Fraud-Card Present Transaction",
  "Fraud-Non Response to Ticket Retrieval Request",
  "Fraud-Processing Error",
  "Fraud-Card-Absent Environment",
  "Fraud-Card-Present Environment",
  "Fraudulent Multiple Transactions",
  "Fraudulent Processing of Transactions",
  "Fraudulent Transaction",
  "Goods or Services Not Provided",
  "Goods/Services Cancelled",
  "Goods/Services Damaged or Defective",
  "Goods/Services Not as Described",
  "Goods/Services Not Received",
  "Goods/Services Returned or Refused",
  "Illegible Sales Data",
  "Immediate Chargeback Program",
  "Incorrect Account Number",
  "Incorrect Amount",
  "Incorrect Charge Amount",
  "Incorrect Currency",
  "Incorrect Currency or Transaction Code or Domestic Processing Violation",
  "Incorrect Currency or Transaction Code or Domestic Transaction Processing Violation",
  "Incorrect Transaction Amount or Account Number",
  "Incorrect Transaction Code",
  "Installment Billing Dispute",
  "Insufficient Reply",
  "Invalid Cardholder Number",
  "Invalid Data",
  "Late Presentation",
  "Late Presentment",
  "Late Submission",
  "Merchandise/Services Not Received",
  "Misrepresentation",
  "Missing Signature",
  "No Authorization",
  "No Cardholder Authorization",
  "No Reply",
  "Non Response to Ticket Retrieval Request",
  "Non-Matching Account Number",
  "Non-Receipt of Cash or Load Transaction Value",
  "Non-Receipt of Goods or Services",
  "Non-Receipt of Requested Item",
  "Nonmatching Card Number",
  "Not as Described or Defective Merchandise",
  "Not as Described or Defective Merchandise/Services",
  "Not Classified",
  "Original Credit Transaction Not Accepted",
  "Other / Unspecified",
  "Other Fraud-Card Absent Environment",
  "Other Fraud-Card Present Environment",
  "Paid by Other Means",
  "Partial Immediate Chargeback Program",
  "Point-of-Interaction Error",
  "Processing Errors Category",
  "Questionable Merchant Activity",
  "Recurring Payments",
  "Requested Copy Illegible or Invalid",
  "Requested Transaction Information Not Received",
  "Requested/Required Authorization Not Obtained",
  "Service Not Provided or Merchandise Not Received",
  "Services Not Provided or Merchandise Not Received",
  "Stored Value Dispute",
  "Transaction Amount Differs",
  "Transaction Not Recognized",
  "Unassigned Card Number",
  "Vehicle Rental – Capital Damages",
  "Vehicle Rental – Theft or Loss of Use",
  "Violation of Operating Regulations",
  "Visa Fraud Monitoring Program",
  "Warning Bulletin File",
  "“No Show” or CARDeposit Cancelled"
]

//if filtersOptions ['Yes', 'No'] you need add this fields to serializeData trueFalseFields array in utils.js
export const defaultOptions = {
  //'alert_status': statuses,
  country: countries,
  enable_auto_refunds: ["Yes", "No"],
  is_use_another_solutions: ["Yes", "No"],
  is_user_notified_previous_solution: ["Yes", "No"],
  is_reissued: ["Yes", "No"],
  applied: ["Yes", "No"],
  customer_unsubscribed: ["Yes", "No"],
  auto_cancel_subscriptions: ["Yes", "No"],
  user_visibility: ["Yes", "No"],
  billable: ["Yes", "No"],
  admin_screenshots: ["Yes", "No"],
  alert_service: ["Ethoca", "RDR", "CDRN"],
  balance_usage: ["Yes", "No"],
  updated_bh: ["Stripe", "Shopify", "None"],
  demo_mode: ["Yes", "No"],
  mode: ["Demo", "Standard", "Light"],
  stripe_charged: ["Yes", "No"],
  loyal_billing: ["Yes", "No"],
  // 'stripe_charged': ['Yes', 'No'],
  charge_by: ["Stripe", "Adyen", "None"],
  locked: ["Yes", "No"],
  status_set: ["Manual", "Auto"],
  credit_request_type: ["No", "Manual", "System"],
  auto_top_up: ["On", "Off"],
  categories: ["Standard", "Referral Partner", "API Partner", "Loyal billing"]
  //example if we need to hide some filter item --> add hidden: true
  // 'example_type': [{name: 'Gift', id: 'Gift'}, {name: 'Withdrawal', id: 'Withdrawal', hidden: true}],
  /*'role': ['Owner', 'Administrator','Manager','View only','No role'],
  'ba_status': [
    {name:'Active', id: 'active'},
    {name: 'Pending', id: 'pending'},
    {name: 'Inactive', id: 'inactive'},
    {name: 'Incomplete', id: 'incomplete'},
    {name: 'Needs help', id: 'needs_help'},
    {name: 'No BA', id: 'none'}
  ],*/
  //alert_reason,
  //request_status: ['Pending', 'Approved', 'Rejected', 'Requires proof', 'Reopened', 'Auto-approved'],
  //request_type: ['manual', 'system'],
  //request_reason: ['Transaction not found', 'Transaction was refunded before the alert', 'Transaction became a chargeback before the alert', 'Alert went to failed/not authenticated transaction', 'Duplicate alerts from Verifi', 'Duplicate alerts from Ethoca', 'Other'],
  //rejection_reason: ['The request reason is invalid','No proof provided','Provided proof is ineligible','Ineligible request','Other'],
}
